import { atom } from "recoil";
import { OrderListTypes, ResListTypes } from "../assets/Type";

export const isMenuView = atom<boolean>({
  key: "isMenuView",
  default: false,
});
export const activeTable = atom<number>({
  key: "activeTable",
  default: 0,
});
export const menuState = atom<number>({
  key: "menuState",
  default: 0,
});
export const popupState = atom<string>({
  key: "popupState",
  default: "none",
});
export const tableOrderList = atom<OrderListTypes[]>({
  key: "tableOrderList",
  default: [
    {
      num: 1,
      time: "12:30:55",
      menu: [
        {
          time: "12:34:14",
          name: "김치고기덮밥",
          ea: 1,
          price: 11000,
          sale: 0,
          total: 11000,
          eta: "-",
        },
        {
          time: "12:34:14",
          name: "콜라",
          ea: 1,
          price: 1500,
          sale: 0,
          total: 1500,
          eta: "-",
        },
      ],
    },
    { num: 2, time: "", menu: [] },
    { num: 3, time: "", menu: [] },
    { num: 4, time: "", menu: [] },
    { num: 5, time: "", menu: [] },
    { num: 6, time: "", menu: [] },
    { num: 7, time: "", menu: [] },
    { num: 8, time: "", menu: [] },
    { num: 9, time: "", menu: [] },
    { num: 10, time: "", menu: [] },
    { num: 11, time: "", menu: [] },
    { num: 12, time: "", menu: [] },
  ],
});
export const resListData = atom<ResListTypes[]>({
  key: "resListData",
  default: [
    {
      state: "요청",
      name: "김재진",
      phone: "010-1234-4567",
      resnum: 23100600008,
      date: "22.10.06(목)오후 07:40",
      people: 2,
      resdate: "22.10.04(수)오후 03:43",
      resway: "하나카드",
      req: "있음",
      detail: false,
    },
    {
      state: "요청",
      name: "홍성택",
      phone: "010-1234-1234",
      resnum: 23100600007,
      date: "22.10.06(목)오후 06:30",
      people: 4,
      resdate: "22.08.25(금)오전 10:58",
      resway: "하나카드",
      req: "있음",
      detail: false,
    },
    {
      state: "취소요청",
      name: "김사라",
      phone: "010-1234-3468",
      resnum: 23100600006,
      date: "22.10.06(목)오후 06:30",
      people: 3,
      resdate: "22.09.22(금)오전 11:04",
      resway: "직접등록",
      req: "-",
      detail: false,
    },
    {
      state: "변경요청",
      name: "이이진",
      phone: "010-1234-1212",
      resnum: 23100600005,
      date: "22.10.06(목)오후 06:00",
      people: 2,
      resdate: "22.09.16(토)오후 02:22",
      resway: "하나카드",
      req: "-",
      detail: false,
    },
    {
      state: "확정",
      name: "강하나",
      phone: "010-1234-3468",
      resnum: 23100600004,
      date: "22.10.06(목)오후 05:30",
      people: 3,
      resdate: "22.10.01(일)오후 07:14",
      resway: "직접등록",
      req: "있음",
      detail: false,
    },
    {
      state: "완료",
      name: "이준성",
      phone: "010-1234-3455",
      resnum: 23100600003,
      date: "22.10.06(목)오후 12:30",
      people: 2,
      resdate: "22.10.01(일)오후 10:12",
      resway: "직접등록",
      req: "-",
      detail: false,
    },
    {
      state: "노쇼",
      name: "배유미",
      phone: "010-1234-5459",
      resnum: 23100600002,
      date: "22.10.06(목)오후 12:30",
      people: 4,
      resdate: "22.10.02(수)오후 08:48",
      resway: "직접등록",
      req: "-",
      detail: false,
    },
    {
      state: "취소",
      name: "김지선",
      phone: "010-1234-5482",
      resnum: 23100600001,
      date: "22.10.06(목)오후 12:00",
      people: 2,
      resdate: "22.09.26(화)오전 10:48",
      resway: "하나카드",
      req: "-",
      detail: false,
    },
  ],
});
export const exData = atom<string>({
  key: "exData",
  default: "",
});
